// src/hooks/TICKET/useTicketInterventions.js

//get interventions by ticket ID
import { useQuery, useMutation, useQueryClient, keepPreviousData } from "@tanstack/react-query";
import { toast } from 'react-toastify';
import { getInterventionsByTicket, postIntervention, updateIntervention, deleteIntervention } from "../../api/TICKET/interventionTicket";

export const useTicketInterventions = (ticketId) => {
  return useQuery({
    queryKey: ["ticket-interventions", ticketId],
    queryFn: () => getInterventionsByTicket(ticketId),
    enabled: !!ticketId, // only if id exists
    staleTime: 2 * 60 * 1000,
    placeholderData: keepPreviousData,
  });
};


export const usePostIntervention = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ ticketId, interventionData }) =>
      postIntervention(ticketId, interventionData),

    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ["ticket-interventions", variables.ticketId] });
    },
  });
};



export const useUpdateIntervention = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ ticketId, interventionId, interventionData }) =>
      updateIntervention(ticketId, interventionId, interventionData),

    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ["ticket-interventions", variables.ticketId] });
      toast.success('Intervention modifiée avec succès');
    },
    onError: (error) => {
      toast.error(error.message || 'Erreur lors de la modification de l\'intervention');
    },
  });
};


export const useDeleteIntervention = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ ticketId, interventionId }) =>
      deleteIntervention(ticketId, interventionId),

    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ["ticket-interventions", variables.ticketId] });
    },
    onError: (error) => {
        toast.error("Erreur lors de la suppression : " + error.message);
    }
  });
};